import { useContext } from "react";

import { ThemeContext, type ThemeContextType } from "@/shared/contexts/ThemeContext";

/**
 * Hook to use the theme context
 * @returns ThemeContextType
 * @throws Error if used outside of ThemeProvider
 */
export function useTheme(): ThemeContextType {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
